import React from "react";
import { useMediaQuery } from "react-responsive";
import StarRatings from "react-star-ratings";
import Slider from "react-slick";

export default function WhyBookHouseCallDoctor({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const settings = {
    infinite: true,
    speed: 700,
    fade: false,
    autoplaySpeed: 7000,
    autoplay: true,
    dots: false,
    draggable: !!isMobile,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: !!isMobile,
    centerPadding: isMobile ? 0 : undefined,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)"
  };

  return (
    <div id="whyBookHouseCallDoctor">
      <div className="title">{content.title}</div>
      <div className="subtitle">{content.subTitle}</div>
      {content.description && <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />}
      {isMobile ? (
        <div className="whyBookHouseCallDoctorMobile">
          <div className="titleContainer">
            {content.tileImagesMobile &&
              content.tileImagesMobile.length > 0 &&
              content.tileImagesMobile.map((tile, index) => (
                <div className="tile" key={index}>
                  <img src={tile?.image?.url} alt="icon" />
                  <div className="tileDescription" dangerouslySetInnerHTML={{ __html: tile.description }} />
                </div>
              ))}
            <div className="partners">
              <div className={content.partnersMobile.partners.length === 1 ? "partnersImage" : "partnersImages"}>
                {content.partnersMobile.partners &&
                  content.partnersMobile.partners.length > 0 &&
                  content.partnersMobile.partners.map((partner, index) => (
                    <img src={partner?.media?.url} alt="icon" key={index} />
                  ))}
              </div>
              <div
                className="partnersDescription"
                dangerouslySetInnerHTML={{ __html: content.partnersMobile.description }}
              />
            </div>
          </div>
          {content.ratings && content.ratings?.length > 0 && (
            <div className="ratingContainer">
              <Slider {...settings}>
                {content.ratings &&
                  content.ratings.length > 0 &&
                  content.ratings.map((rate, index) => (
                    <div className="ratingCard" key={index}>
                      <StarRatings
                        name="rating"
                        rating={rate.stars ? parseFloat(rate.stars) : 5}
                        starDimension="18px"
                        numberOfStars={5}
                        starRatedColor="#282828"
                        starSpacing="2px"
                      />
                      <div className="description">{rate.description}</div>
                      <div className="author">
                        <div className="authorName">{rate.location ? rate.author.concat(",") : rate.author}</div>
                        <div className="authorLocation">{rate.location}</div>
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          )}
        </div>
      ) : (
        <div className="whyBookHouseCallDoctorDesktop">
          <div className="titleContainer">
            {content.tileImagesDesktop &&
              content.tileImagesDesktop.length > 0 &&
              content.tileImagesDesktop.map((tile, index) => (
                <div className="tile" key={index}>
                  <img className="imageWrapper" src={tile?.image?.url} alt="icon" />
                  <div className="tileDescription" dangerouslySetInnerHTML={{ __html: tile.description }} />
                </div>
              ))}
            <div className="partners">
              <div className={content.partnersDesktop.partners.length === 1 ? "partnersImage" : "partnersImages"}>
                {content.partnersDesktop.partners &&
                  content.partnersDesktop.partners.length > 0 &&
                  content.partnersDesktop.partners.map((partner, index) => (
                    <img src={partner?.media?.url} alt="icon" key={index} />
                  ))}
              </div>
              <div
                className="partnersDescription"
                dangerouslySetInnerHTML={{ __html: content.partnersMobile.description }}
              />
            </div>
          </div>
          {content.ratings && content.ratings?.length > 0 && (
            <div className="ratingContainer">
              <Slider {...settings}>
                {content.ratings &&
                  content.ratings.length > 0 &&
                  content.ratings.map((rate, index) => (
                    <div className="ratingCard" key={index}>
                      <StarRatings
                        name="rating"
                        rating={rate.stars ? parseFloat(rate.stars) : 5}
                        starDimension="18px"
                        numberOfStars={5}
                        starRatedColor="#282828"
                        starSpacing="2px"
                      />
                      <div className="description" dangerouslySetInnerHTML={{ __html: rate.description }} />
                      <div className="author">
                        <div className="authorName">{rate.location ? rate.author.concat(",") : rate.author}</div>
                        <div className="authorLocation">{rate.location}</div>
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
